import { getTileSetById, getTileUrl, useTileCatalogStore } from "@west-marches/shared";

interface EyedropperOverlayProps {
  clientX: number;
  clientY: number;
  hoveredTileSetId: string | null;
}

export function EyedropperOverlay({ clientX, clientY, hoveredTileSetId }: EyedropperOverlayProps) {
  const catalogRevision = useTileCatalogStore((s) => s.revision);
  const tooltipTileSet = hoveredTileSetId ? getTileSetById(hoveredTileSetId) : null;

  return (
    <>
      <div
        data-catalog-revision={catalogRevision}
        aria-hidden="true"
        className="pointer-events-none fixed z-20 h-6 w-6 drop-shadow-[0_2px_6px_rgba(0,0,0,0.8)]"
        style={{
          left: clientX,
          top: clientY,
          transform: "translate(-50%, -50%)",
        }}
      >
        <span className="absolute left-1/2 top-0 h-full w-0.5 -translate-x-1/2 bg-white" />
        <span className="absolute left-0 top-1/2 h-0.5 w-full -translate-y-1/2 bg-white" />
      </div>
      {tooltipTileSet && (
        <div
          className="pointer-events-none fixed z-20 flex items-center gap-2 rounded-full border border-white/20 bg-black/75 px-2 py-1 text-white shadow-lg backdrop-blur-sm"
          style={{
            left: clientX + 26,
            top: clientY + 22,
          }}
        >
          <img
            src={getTileUrl(tooltipTileSet.tileIds[0]) ?? ""}
            alt={tooltipTileSet.label}
            className="h-8 w-8 rounded-full object-cover"
            draggable={false}
          />
          <span className="text-xs font-medium whitespace-nowrap">
            {tooltipTileSet.label}
          </span>
        </div>
      )}
    </>
  );
}
